import './en';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/ngx-bootstrap/bs-moment/locale/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/locale/index.js
// module chunks = 4